import {ModbusConfig} from './modbus';
import {UserId} from './user';
import {AutoClearSetting} from './alarm';
import {HubId} from './hub';
import {FormulaConfig} from './formula-config';
import {LoRaWANConfig} from './lorawan';

export enum DeviceType {
  BACnet = 'bacnet',
  Modbus = 'modbus',
  LoRaWAN = 'lorawan',
  Formula = 'formula',
}

export const DEVICE_TYPE_DISPLAY: Record<DeviceType, string> = {
  [DeviceType.BACnet]: 'BACnet',
  [DeviceType.Modbus]: 'Modbus',
  [DeviceType.LoRaWAN]: 'LoRaWAN',
  [DeviceType.Formula]: 'Formula',
};

// Physical device types — excludes virtual/formula devices
export type PhysicalDeviceType = Exclude<DeviceType, DeviceType.Formula>;

export interface Device<T extends DeviceType = DeviceType> {
  ID?: DeviceId;
  Name: string;
  IP: string;
  Address: string; // e.g. the BACnet address
  Hub: HubId;
  Owner: UserId;
  Type: T; // should have been called "Protocol" ... oh well
  Config?: DeviceConfig;
}

export interface DevicePatch {
  Hub?: string;
  Name?: string;
  IP?: string;
  Address?: string; // e.g. the BACnet address
  Config?: DeviceConfig;
}

export interface DeviceConfig {
  Modbus?: ModbusConfig;
  Formula?: FormulaConfig;
  LoRaWAN?: LoRaWANConfig;
  Policies: DevicePolicies;
  AutoClear: AutoClearSetting;
}

export interface DevicePolicies {
  Tuning?: DeviceTuningPolicy;
}

export interface DeviceTuningPolicy {
  DisableCircuitBreaker: null | boolean;
  ReadDataStaleAfterSeconds: null | number;
}

export type DeviceId = string;

export type DeviceIdMap = { [deviceId: DeviceId]: Device };
